import { render } from "./PaletteDialog.vue?vue&type=template&id=b16a3086"
import script from "./PaletteDialog.vue?vue&type=script&lang=js"
export * from "./PaletteDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Git\\led2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__